import { Component } from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './ManualCompany.messages';
import styles from './ManualCompany.module.css';
import { TextInput } from '../../../../forms/formField/Input';

export class ManualCompany extends Component {
    onCompanyNameChange = (value) => {
        this.props.companyName.input.onChange(value);
        this.props.onChangePrompt(value);
    };

    onCompanyNumberChange = (value) => {
        this.props.companyNumber.input.onChange(value);
        this.props.onChangePrompt(value);
    };

    render() {
        const { companyName, companyNumber } = this.props;

        const companyNameInput = {
            ...companyName,
            input: {
                ...companyName.input,
                onChange: this.onCompanyNameChange
            },
            id: 'companyName',
            disabled: true
        };

        const companyNumberInput = {
            ...companyNumber,
            input: {
                ...companyNumber.input,
                onChange: this.onCompanyNumberChange
            },
            id: 'companyNumber',
            disabled: true
        };

        return (
            <div className={styles.ManualCompany}>
                <div className={styles.registeredName}>
                    <label htmlFor="companyName">
                        <FormattedMessage {...messages.registeredName} />
                    </label>
                    <TextInput {...companyNameInput} />
                </div>
                <div className={styles.registeredNumber}>
                    <label htmlFor="companyNumber">
                        <FormattedMessage {...messages.registeredNumber} />
                    </label>
                    <TextInput {...companyNumberInput} />
                </div>

                {/*TODO - this should be added back in once backend supports updating company name/number<div*/}
                {/*className={styles.toggleManualCompany}*/}
                {/*onClick={toggleManualCompanyState}>*/}
                {/*<FormattedMessage {...messages.manualCompanyText} />*/}
                {/*</div>*/}
            </div>
        );
    }
}
